<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :linkback="linkback" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Presidio:</label>
                        <b-form-select id="inline-form-custom-select-pref" v-model="filtroConfigurazioneLaboratori.codicePresidio" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="idPresidio" text-field="denominazionePresidio" :options="presidiOptions"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice Laboratorio:</label>
                        <b-form-input v-model="filtroConfigurazioneLaboratori.codiceLaboratorio" type="search" id="codice" placeholder="Codice Laboratorio"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Descrizione Laboratorio:</label>
                        <b-form-input v-model="filtroConfigurazioneLaboratori.descrizioneLaboratorio" type="search" id="descrizione" placeholder="Descrizione Laboratorio"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-configurazione-laboratori-list-component ref="RsaConfigurazioneLaboratoriListComponent" @afterLoadData="onAfterLoadData" @updateFilter="onUpdateFilter" @beforeLoadData="onBeforeLoadData" />
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneLaboratoriListComponent from "../components/RsaConfigurazioneLaboratoriListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: { SaPageLayout, RsaConfigurazioneLaboratoriListComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            filtroConfigurazioneLaboratori: { codiceLaboratorio: null, descrizioneLaboratorio: null, codicePresidio: null },
            btnNewVisible: true,
            btnBackVisible: true,
            linkback: "/home",
            pathResource: "/rsalaboratori",
            linkConfigurazioni: "/configurazioni",
            linkedit: "/rsaconfigurazionelaboratori",
            pathResourcePresidi: "/strutturepresidi",
            pathResourceUtentePresidi: "/utentipresidi",
            showModalLoading: false,
            listKey: 0,
            presidiOptions: [],
        };
    },
    mounted() {
        let me = this;
        me.loadData();
        //   me.loadPresidi();
        me.loadDataUtentePresidi();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.RsaConfigurazioneLaboratoriListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onReset() {
            let me = this;
            me.filtroConfigurazioneLaboratori = { codiceLaboratorio: null, descrizioneLaboratorio: null, codicePresidio: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneLaboratori"] = JSON.stringify(me.filtroConfigurazioneLaboratori);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneLaboratori"] = JSON.stringify(me.filtroConfigurazioneLaboratori);
            me.loadData();
        },
        loadPresidi() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePresidi;
            me.presidiOptions = [];

            axios
                .get(link)
                .then((response) => {
                    me.presidiOptions = response.data.data.list;
                    me.presidiOptions.unshift({
                        id: null,
                        denominazione: "-Seleziona Presidio-",
                    });
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        loadDataUtentePresidi() {
            let me = this;
            if (sessionStorage.getItem("user")) {
                let utente = JSON.parse(sessionStorage.getItem("user"));
                me.loadDataResources(me.pathResourceUtentePresidi, { idUtente: utente.id }, me.resultResponseUtentePresidi, me.resultErrorUtentePresidi);
            }
        },
        resultResponseUtentePresidi(response) {
            let me = this;
            me.presidiOptions = response.data.data.list;
            me.presidiOptions.unshift({
                idPresidio: null,
                denominazionePresidio: "-Seleziona Presidio-",
            });
        },
        resultErrorUtentePresidi(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore nel caricamento dei Presidi";
            me.$bvToast.toast(messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onUpdateFilter(filterData) {
            this.filtroConfigurazioneLaboratori = filterData;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
    },
};
</script>

<style></style>
